<style>
</style>
<template>
<v-row>
  <v-col cols="12" xs="12" sm="6" class="ma-0 px-2 py-0">
    <setting-value name="name" v-model="firstName" required :counter="32"></setting-value>
  </v-col>
  <v-col cols="12" xs="12" sm="6" class="ma-0 px-2 py-0">
    <setting-value name="surname" v-model="lastName" required :counter="32"></setting-value>
  </v-col>
</v-row>
</template>
<script>
import SettingValue from '../components/setting-value.vue'
import TransformMixin from '../mixins/transform-mixin.js'
export default {
  name: 'setting-name',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    defaultValue: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    'setting-value': SettingValue
  },
  mixins: [TransformMixin],
  data() {
    return {
      inputValue: this.value ? this.value : {}
    }
  },
  computed: {
    firstName: {
      get() {
        return this.inputValue.firstName
      },
      set(value) {
        this.inputValue.firstName = value
        this.$emit('input', this.inputValue)
      }
    },
    lastName: {
      get() {
        return this.inputValue.lastName
      },
      set(value) {
        this.inputValue.lastName = value
        this.$emit('input', this.inputValue)
      }
    }
  }
}
</script>
